<template>
  <div>
    <el-drawer
      title="批量分配任务"
      :visible="visible"
      :size="1194"
      :destroy-on-close="true"
      :before-close="customCloseDrawer"
    >
    <div style="height:100%">
      <!-- <AssignTelephoneTask /> -->
      <AssignTelephoneTask
        :data="selectedInterviewerInfo"
        @comeback="comebackHandler"
        :title="$store.getters.title"
        @emitChange="$emit('changeDialogVisible', true)"
      />
    </div>
    </el-drawer>
  </div>
</template>
<script>
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { putOfflineTask } from '@/api/wenjuan/offline.js' //编辑任务API
import { plCreat } from '@/api/wenjuan/addList.js' // 添加任务API
import store from '@/store'
import Advert from '@/components/interview/advert/index.vue'
import AssignTelephoneTask from '@/views/survey/cati/components/AssignTelephoneTask.vue'
export default {
  components: { OverMask, Advert, AssignTelephoneTask },
  props: ['visible','selectedInterviewerInfo'],
  watch: {
  },
  computed: {
  },
  data() {
    return {
      
    }
  },
  methods: {
    customCloseDrawer() {
      this.$emit('callbackClose', false)
    },
    comebackHandler(){
      this.$emit('callbackClose', false)
    }
  },
  mounted() {
    this.isOpen = store.getters.settlementType !== 1
  }
}
</script>
<style lang="scss" scoped>

</style>